module.exports = __webpack_public_path__ + "img/zhewan3.84921ca0.png";